module.exports = __webpack_public_path__ + "img/DSC_1102.1cf27553.jpg";